<script setup lang="ts">
import GoogleLogo from "@/assets/third_party/logos/google_logo_black.svg";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-vue-next";

const props = withDefaults(defineProps<{
    isLoggedIn?: boolean;
    redirect?: string;
    buttonText?: string;
    disabled?: boolean;
    fadeIn?: boolean;
}>(), {
    buttonText: "Butlerbot Login",
});

const fullRedirect = props.redirect ? "?redirect=" + props.redirect : "";
</script>

<template>
    <div :class="{ 'animate_popin': fadeIn }">
        <template v-if="disabled">
            <Button style="font-size: 16px; text-transform: capitalize" size="lg" variant="highlight" disabled>
                <img :src="GoogleLogo.src" alt="icon" class="tw-w-5 tw-h-5 tw-mr-2" />
                ButlerBot Login
            </Button>
        </template>
        <template v-else-if="isLoggedIn">
            <Button style="font-size: 16px; text-transform: capitalize" size="lg" variant="success" disabled>
                <Check :size="24" class="tw-mr-2" />
                Logged In
            </Button>
        </template>
        <template v-else>
            <Button style="font-size: 16px; text-transform: capitalize" size="lg" variant="highlight" as-child>
                <a :href="`/login${fullRedirect}`">
                    <img :src="GoogleLogo.src" alt="icon" class="tw-w-5 tw-h-5 tw-mr-2" />
                    {{ buttonText }}
                </a>
            </Button>
        </template>
    </div>
</template>
